export default __webpack_public_path__ + "static/media/VGB.76fedc33.svg";